import
  React
from "react";

import {
  showSpinner,
} from "../../../utils/helperServices";

import {
  connect,
} from "../../atoms/DependencyHelper";

import {
  HeaderContainer,
  HeaderSpace,
  HContainer,
  Cart,
  CartCounter,
  Logo,
  Menu,
  Divider,
  MenuContent,
  MenuContentItem,
  MenuOverlayContainer,
} from './miniAppStyled';

import {
  MiniAppMenuItems,
} from "../constants";

const MiniAppHeaderComponent = ({
  cartTotalQuantity,
  router
}) => {

  const [menuItems, setMenuItems] = React.useState([]);
  const [cartQuantity, setCartQuantity] = React.useState(cartTotalQuantity);
  const [showMenuContent, setShowMenuContent] = React.useState(false);

  const onLogoClick = (e) => {

    if (window.location.pathname === "/shopping/products") {
      return;
    }

    e.stopPropagation();
    showSpinner();
    setShowMenuContent(false);
    router.push("/shopping/products");
  };

  const onCartClick = (e) => {

    if (window.location.pathname === "/shopping/cart") {
      return;
    }

    e.stopPropagation();
    showSpinner();
    setShowMenuContent(false);
    router.push("/shopping/cart");
  };

  const onMenuItemClick = (e, path) => {

    if (!path || window.location.pathname === path) {
      return;
    }

    e.stopPropagation();
    showSpinner();
    setShowMenuContent(false);
    router.push(path);
  };

  const onMenuClick = (e) => {

    e.stopPropagation();
    setShowMenuContent(!showMenuContent);
  };

  React.useEffect(() => {

    setCartQuantity(cartTotalQuantity);
  }, [cartTotalQuantity]);

  React.useEffect(() => {

    if (!MiniAppMenuItems || MiniAppMenuItems.length === 0) {
      return;
    }

    const mItems = [];

    for (const menuItem of MiniAppMenuItems) {

      mItems.push(
        <MenuContentItem
          onClick={(e) => onMenuItemClick(e, menuItem.path)}>
            {menuItem.display}
        </MenuContentItem>
      );
    }

    setMenuItems(mItems);

  }, []);

  return (
    <>

      <div>{/* Leave this div here. It is used to get past a NextJS issue */}</div>
      <HeaderSpace/>

      <HeaderContainer>
        
        <Logo
          onClick={onLogoClick}
        />

        <HContainer>

          <Cart
            onClick={onCartClick}>

              {!!cartQuantity && <CartCounter>{cartQuantity}</CartCounter>}
          </Cart>

          <Divider/>

          <Menu
            image={showMenuContent ? "close-black.svg" : "hb-lines.png"}
            onClick={onMenuClick}
          />

        </HContainer>

      </HeaderContainer>

      <MenuContent
        show={showMenuContent}
        numberOfItems={menuItems.length}>

        {menuItems}

      </MenuContent>

      { showMenuContent &&
      
        <MenuOverlayContainer
          onTouchEnd={() => setShowMenuContent(false)}
        />
      }

    </>
  );
};

const mapStateToProps = (state) => ({
  cartTotalQuantity: state.cartDetails.totalQuantity,
});

export const MiniAppHeader = connect(mapStateToProps)(MiniAppHeaderComponent);
